import { networkClient } from '@network/networkClient'
import { getGlobalParams } from '../globalParams'
import {
  GET_TOURNAMENTS,
  GET_TOURNAMENTS_HISTORY,
  GET_TOURNAMENT_ACTIVE_LEADERBOARD,
  GET_TOURNAMENT_LEADERBOARD_HISTORY,
  GET_TOURNAMENT_PRIZES,
  TOURNAMENT_OPT_IN,
} from '../queries/tournamentQueries'
import { logger } from '@logger'

const MODULE = 'Tournament Service'

export const getTournaments = async ({ tournamentStatus, page = 1, pageSize = 10 } = {}) => {
  const { playerId, operatorId, brandId, currency, gameCode } = getGlobalParams()

  const response = await networkClient({
    request: {
      query: GET_TOURNAMENTS,
      variables: {
        playerId,
        operatorId,
        brandId,
        currency,
        gameCode,
        tournamentStatus,
        size: pageSize,
        page,
      },
    },
  })

  logger.info(MODULE, 'getTournaments Response', response)

  if (response.players.getTournaments.success) {
    return { ...response.players.getTournaments.data, page, pageSize }
  } else {
    throw new Error(response.players.getTournaments.message || 'Failed to fetch tournaments')
  }
}

export const getTournamentsHistory = async ({ page = 1, pageSize = 10 } = {}) => {
  const { playerId, operatorId, brandId, currency, gameCode } = getGlobalParams()

  const response = await networkClient({
    request: {
      query: GET_TOURNAMENTS_HISTORY,
      variables: { playerId, operatorId, brandId, currency, gameCode, size: pageSize, page },
    },
  })

  logger.info(MODULE, 'getTournamentsHistory Response', response)

  if (response.players.getTournamentsHistory.success) {
    return { ...response.players.getTournamentsHistory.data, page, pageSize }
  } else {
    throw new Error(
      response.players.getTournamentsHistory.message || 'Failed to fetch tournaments history'
    )
  }
}

export const getTournamentActiveLeaderboard = async ({
  tournamentId,
  page = 1,
  pageSize = 10,
} = {}) => {
  const response = await networkClient({
    request: {
      query: GET_TOURNAMENT_ACTIVE_LEADERBOARD,
      variables: { tournamentId, size: pageSize, page },
    },
  })

  logger.info(MODULE, 'getTournamentActiveLeaderboard Response', response)

  if (response.players.getTournamentActiveLeaderboard.success) {
    return { ...response.players.getTournamentActiveLeaderboard.data, page, pageSize }
  } else {
    throw new Error(
      response.players.getTournamentActiveLeaderboard.message ||
        'Failed to fetch active leaderboard'
    )
  }
}

export const getTournamentLeaderboardHistory = async ({
  tournamentId,
  page = 1,
  pageSize = 10,
} = {}) => {
  const response = await networkClient({
    request: {
      query: GET_TOURNAMENT_LEADERBOARD_HISTORY,
      variables: { tournamentId, size: pageSize, page },
    },
  })

  logger.info(MODULE, 'getTournamentLeaderboardHistory Response', response)

  if (response.players.getTournamentLeaderboardHistory.success) {
    return { ...response.players.getTournamentLeaderboardHistory.data, page, pageSize }
  } else {
    throw new Error(
      response.players.getTournamentLeaderboardHistory.message ||
        'Failed to fetch leaderboard history'
    )
  }
}

export const getTournamentPrizes = async ({ tournamentId } = {}) => {
  const response = await networkClient({
    request: { query: GET_TOURNAMENT_PRIZES, variables: { tournamentId } },
  })

  logger.info(MODULE, 'getTournamentPrizes Response', response)

  if (response.players.getTournamentPrizes.success) {
    return response.players.getTournamentPrizes.data
  } else {
    throw new Error(response.players.getTournamentPrizes.message || 'Failed to fetch prizes')
  }
}

// Opt in/out of a tournament (mutation-like action). playerId from session;
// component passes only { tournamentId, optInStatus }.
export const tournamentOptIn = async ({ tournamentId, optInStatus } = {}) => {
  const { playerId } = getGlobalParams()

  const response = await networkClient({
    request: { query: TOURNAMENT_OPT_IN, variables: { tournamentId, playerId, optInStatus } },
  })

  logger.info(MODULE, 'tournamentOptIn Response', response)

  if (response.players.tournamentOptIn.success) {
    return response.players.tournamentOptIn.data
  } else {
    throw new Error(response.players.tournamentOptIn.message || 'Failed to opt in to tournament')
  }
}
